/* eslint-disable jsx-a11y/label-has-associated-control */
import * as React from 'react';

type ToggleInputProps = {
  className?: string;
  name: string;
  id?: string;
  disabled?: boolean;
  error?: boolean;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function ToggleInput({
  className,
  name,
  id,
  disabled,
  error,
  checked,
  value,
  onChange,
}: ToggleInputProps) {
  return (
    <span className="relative inline-block w-[42px] align-middle select-none transition duration-200 ease-in">
      <input
        type="checkbox"
        name={name}
        id={id}
        className={`${className} ${
          error ? 'text-river-red' : ''
        } toggle appearance-none cursor-pointer absolute block w-[23px] h-[23px] rounded-full bg-white border-1 z-0 border-gray-300 
        focus:ring-0 focus:ring-offset-0 focus:border-1 focus:outline-none focus:shadow-none focus:shadow-transparent
        checked:right-0 checked:pos-green checked:bg-white checked:!border-1 checked:!border-pos-green
       hover:bg-white checked:hover:bg-white checked:hover:border-pos-green checked:focus:bg-white`}
        disabled={disabled}
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <label
        htmlFor={id}
        className="toggle block overflow-hidden h-[23px] rounded-full bg-gray-300 cursor-pointer"
      />
    </span>
  );
}

ToggleInput.defaultProps = {
  className: '',
  id: '',
  disabled: false,
  error: false,
};

export default ToggleInput;
